import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'

const api = {
  update: `/keyword/update`,
  remove: `/keyword/delete`,
  list: `/keyword/list`,
  add: `/keyword/add`,
  batchadd: `/keyword/batchadd`,
}

// 移除
export function removeItem (data) {
  return axios({
    url: api.remove,
    method: 'post',
    data: filterData(data),
    func:'移除'
  })
}

// 查询关键词列表
export function queryList (params) {
  return axios({
    url: api.list,
    method: 'get',
    params: filterData(params),
    func:'查询关键词列表'
  })
}
//编辑
export function updateItem (data) {
  return axios({
    url: api.update,
    method: 'post',
    data: filterData(data),
    func:'编辑'
  })
}
//新增
export function addItem (data) {
  return axios({
    url: api.add,
    method: 'post',
    data: filterData(data),
    func:'新增'
  })
}
//批量导入
export function batchadd (data) {
  return axios({
    url: api.batchadd,
    method: 'post',
    data: filterData(data),
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    func:'批量导入'
  })
}

